module.exports = __webpack_public_path__ + "img/commercetools-2024-logo-in-SVG-format-black-version.520fa4c5.svg";